import {
  GET_ROLE_DONATION_STATS,
  receiveRoleDonationStats,
} from "@/components/donations/volunteer/ducks/Actions"
import { apiGetRoleDonationStats } from "@/components/donations/volunteer/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const receiveRoleDonationStatsSuccess = (cb) => (response) => {
    dispatch(receiveRoleDonationStats(response.stats))
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case GET_ROLE_DONATION_STATS:
      apiGetRoleDonationStats(receiveRoleDonationStatsSuccess(action.success), action.error)
      return next(action)

    default:
      return next(action)
  }
}
